import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import AlertNotificationIcon from "../../../assets/icons/monitoring/alerts_notifications-01.svg2";
import AvailableUpgrades from "../../Dashboard/AvailableUpgrades";
import { useGetInteractionsWidgetDataQuery } from "../../store/slices/widgetsSlice";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

export default function UrgentAttentionWidget() {
  const { data = { used: 0, remaining: 0 } } =
    useGetInteractionsWidgetDataQuery();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonth = months[new Date().getMonth()];
  const currentYear = new Date().getFullYear();

  return (
    <div className="h-100 p-3 text-white rounded-3">
      <div className="card-body">
        <div className="">
          <AlertNotificationIcon width={20} className="me-2 white opacity-50" />
          <span className="small fw-bold widget-header">URGENT ATTENTION </span>
          <HelpButton helpKey="widget-urgent-attention" iconClassName="white" />
        </div>
        <NewFeature>
          <hr className="text-white my-2" />
          <div className="row p-2 text-center">
            <div className="bg-dark bg-opacity-25 rounded-3 px-2 py-3 col-6">
              <div className="fw-bold small">CURRENT ITEMS</div>
              <div className="opacity-50 " style={{ fontSize: "0.75rem" }}>
                interactions used
              </div>
              <div className="display-3 fw-bold">{data.used}</div>
              <div className="opacity-50" style={{ fontSize: "0.75rem" }}>
                {currentMonth} - {currentYear}
              </div>
            </div>
            <div className="px-2 py-3 col-6">
              <div className="fw-bold small">UNUSED ITEMS</div>
              <div className="opacity-50" style={{ fontSize: "0.75rem" }}>
                refreshes monthly
              </div>
              {data.remaining === -1 ? (
                <div>
                  <div className="display-3 fw-bold">
                    <FontAwesomeIcon icon={faInfinity} />
                  </div>
                  UNLIMITED
                </div>
              ) : (
                <div>
                  <div className="display-3 fw-bold">{data.remaining}</div>
                  <AvailableUpgrades />
                </div>
              )}
            </div>
          </div>
        </NewFeature>
      </div>
    </div>
  );
}
